export const BLOG_POSTS = [
  {
    slug: "decoding-new-trends",
    title: "Decoding New Trends for Age-Old Traditions",
    excerpt:
      "How we blend contemporary style with timeless wedding moments. From pre-wedding shoots to the big day.",
    image: "/d5.jpg",
    date: "2025-01-15",
  },
  {
    slug: "more-than-photos",
    title: "Because Your Wedding Deserves More Than Just Photos",
    excerpt:
      "Why we believe in films, storytelling, and capturing the chaos — not just the poses.",
    image: "/a10.jpg",
    date: "2025-01-08",
  },
  {
    slug: "madness-and-chaos",
    title: "Capturing the Madness and Chaos We Call Weddings",
    excerpt:
      "Behind the scenes: how we find order in the beautiful chaos of Indian weddings.",
    image: "/d10.jpg",
    date: "2024-12-20",
  },
 
];
